/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentDto } from '../../models/content-dto';

export interface AdminContentControllerTogglePin$Params {
  id: string;
}

export function adminContentControllerTogglePin(http: HttpClient, rootUrl: string, params: AdminContentControllerTogglePin$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentDto>> {
  const rb = new RequestBuilder(rootUrl, adminContentControllerTogglePin.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentDto>;
    })
  );
}

adminContentControllerTogglePin.PATH = '/api/content/admin/{id}/pin';
